module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/flow-arrow-c7a8dc14fbf811bd90baeead9c49bd43.png";